import { FC } from "react";
import classNames from "classnames";
import { useTranslations } from "next-intl";

import { countriesList } from "./utils";
import { IShippingCountry } from "@/types/apiResponse.types";

type Props = {
  selectedCountryId: number;
  selectCountry: (id: number) => void;
  countriesData: IShippingCountry[];
  isAddParcel?: boolean;
  disabled?: boolean;
};

const CountriesList: FC<Props> = ({
  selectedCountryId,
  selectCountry,
  countriesData,
  isAddParcel = false,
  disabled = false,
}) => {
  const t = useTranslations();

  return (
    <div
      className={classNames("flex w-[600px] flex-wrap gap-5", {
        "mb-10": !isAddParcel,
      })}
    >
      {countriesData?.map((item) => {
        const Icon =
          countriesList.find((e) => e.id === item.countryId)?.icon || null;

        return (
          <div
            key={item.countryName}
            className={classNames(
              "flex items-center gap-2 rounded-[26px] border-2 border-transparent p-3",
              {
                "bg-white":
                  selectedCountryId !== item.countryId && !isAddParcel,
                "bg-[#f9f9f9]":
                  selectedCountryId !== item.countryId && isAddParcel,
                "secondary-bg primary-border":
                  selectedCountryId === item.countryId,
                "cursor-not-allowed opacity-50": disabled,
                "cursor-pointer": !disabled,
              },
            )}
            onClick={() => {
              !disabled && selectCountry(item.countryId);
            }}
          >
            {Icon && <Icon className="h-[28px] w-[28px]" />}
            <span className="truncate uppercase">{t(item.countryName)}</span>
          </div>
        );
      })}
    </div>
  );
};

export { CountriesList };
